export enum BoardViewTemplateIdsEnum {
  MY_DISPUTES = 'myDisputesTemplate',
  OPEN_DISPUTES = 'openDisputesTemplate',
  HISTORICAL = 'historicalDisputesTemplate',
}
